import {Konfigurasjon} from "felles/infrastruktur/Konfigurasjon";
import {IAngularEvent, IController, IModule, IOnChangesObject} from "angular";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import _ from "lodash";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {BegrensSøkTil} from "./søk";
import {SøkTjeneste, TilgjengeligEntitet} from "felles/tjenester/modulspesifikke/SøkTjeneste";
import {EntitetType} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";

const css = require('./søketreff.scss');

export class SøketreffKontroller implements IController {
    static registrerKomponent(angular: IModule) {
        angular
            .component('wmSoektreff', {
                bindings: {
                    treff: '<',
                    menyDeaktivert: '<',
                    vedBegrensTil: '&',
                    vedNavigerTilTreff: '&'
                },
                controller: SøketreffKontroller.forInjisering(),
                template: require('./søketreff.html')
            });
    }

    static forInjisering() {
        return [
            Konfigurasjon.regNavn,
            SøkTjeneste.regNavn,
            WebNavigasjon.regNavn,
            Kontekst.regNavn,
            SøketreffKontroller
        ]
    }

    constructor(private konfigurasjon: Konfigurasjon,
                private søkTjeneste: SøkTjeneste,
                private webnavigasjon: WebNavigasjon,
                private kontekst: Kontekst) {
    }

    static entiteterSomStøtterVisLiknende = ['OpplastetDokumentVersjon', 'Sak'];

    treff: l.SearchHit; //settes via bindings/$onChanges
    menyDeaktivert: boolean; //settes via bindings/$onChanges
    vedBegrensTil: (arg: { spesifikasjon: BegrensSøkTil; }) => any; //settes via bindings/$onChanges
    vedNavigerTilTreff: (arg: { treff: l.SearchHit; }) => any; //settes via bindings/$onChanges

    kilde: { [felt: string]: any };
    gruppe: l.EnkelGruppeModell;
    entitet: TilgjengeligEntitet;
    stoetterVisLiknende = false;


    visLiknende($event:IAngularEvent) {
        $event.preventDefault();
        $event.stopPropagation();
        this.vedBegrensTil({spesifikasjon: {treffValgtForVisLiknende: this.treff}});
    }

    visKunGruppe($event:IAngularEvent) {
        $event.preventDefault();
        $event.stopPropagation();
        this.vedBegrensTil({spesifikasjon: {gruppe: this.gruppe.id}});
    }

    visKunEntitet($event: IAngularEvent) {
        $event.preventDefault();
        $event.stopPropagation();
        this.vedBegrensTil({spesifikasjon: {entitet: this.treff._type}});
    }

    erArkivDokument(){
        return this.kilde.dokforeldertype == l.DokumentType.arkivdokument;
    }

    gaaTilTreff() {
        this.vedNavigerTilTreff({treff: this.treff});
        const entitetId = this.treff._id;

        switch (this.treff._type.toLowerCase()) {
            case 'opplastetdokumentversjon':
                if (this.erArkivDokument())
                    this.webnavigasjon.gåTilArkivdokumentKnyttetTilDokumentVersjon(entitetId, true); //relast=true ellers skjer ingen ting dersom søket gjøres når man står i arkivmodulen
                else
                    this.webnavigasjon.gåTilSakKnyttetTilDokumentVersjon(entitetId);
                return;
            case 'medlem':
                this.webnavigasjon.gåTilMedlem(this.kilde.gruppe, entitetId);
                return;
            case 'sak':
                this.webnavigasjon.gåTilSak2(this.kilde.møteId, entitetId);
                return;
            case 'beslutning':
                this.webnavigasjon.gåTilBeslutning2(this.kilde.møteId, this.kilde.sakId, entitetId);
                return;
            case 'kommentar':
            case 'svar':
                switch (this.kilde.forelderinfo.type) {
                    case 'DokumentAnnotering':
                        return this.webnavigasjon.gåTilDokumentKnyttetTilDokumentAnnotering(this.kilde.forelderinfo.id);
                    case 'Sak':
                        return this.webnavigasjon.gåTilSak(this.kilde.forelderinfo.id);
                    case 'Oppgave':
                        return this.webnavigasjon.gåTilOppgave(this.kilde.forelderinfo.id);
                }
                console.warn('ukjent foreldertype for kommentartreff', this.treff);
                return;
            default:
                this.webnavigasjon.gåTilEntitetRef({id: entitetId, type: this.treff._type.toLowerCase() as EntitetType});
                return;
        }


        /*
        TREFF PÅ KOMMENTAR DOK
        "_index" : "lederplan",
      "_type" : "Kommentar",
      "_id" : "7c7dfd8b-c981-4a03-b894-b32675c67ab1",
      "_score" : 0.7010463,
      "_source" : {
        "forfatter" : "Henry J. Wengstrøm",
        "gruppe" : "b3dabc14-726a-41f4-93ad-e79ecff001f1",
        "kommentar" : "Skal vi revidere denne avtaleteksten?",
        "dato" : "2007-12-02T09:15:00.000Z",
        "foreldertype" : "DokumentAnnotering",
        "forelderinfo" : {
          "malnavn" : "dokumentannoteringkommentar",
          "noeklerOgVerdier" : {
            "dokument" : "dokument.pdf",
            "mappenavn" : "It"
          }
        }
      },
      "highlight" : {
        "kommentar" : [ "Skal vi <em>revidere</em> denne avtaleteksten?" ]
      }
    }, {
         */
    }

    utdrag(felt) {
        if (!this.treff.highlight[felt]) return '';
        return _(this.treff.highlight[felt])
            .reduce((prev, curr) => `${prev} (...) ${curr}`)
    }

    $onChanges(changes: IOnChangesObject): void {
        if (changesInneholder(changes, 'treff'))
            this.initMedTreff(this.treff);
    }

    //hjelpemetoder

    private initMedTreff(treff: any) {
        this.treff = treff;
        this.kilde = this.treff._source;
        this.gruppe = this.kontekst.finnAutentiserteGruppe(this.kilde.gruppe);
        this.entitet = this.søkTjeneste.entitetBasertPåEsType(this.treff._type);
        this.stoetterVisLiknende = _.includes(SøketreffKontroller.entiteterSomStøtterVisLiknende, this.treff._type);
    }

}
